import { Button, errorToast, toast } from '@/components/ui'
import { $api, $client } from '@/lib/fetch'
import { prettyBytes, prettyTimestamp } from '@/lib/helpers'

export default function AdminSnapshots() {
  const { isLoading, data, error, isError, refetch } = $api.useQuery(
    'get',
    '/api/snapshots',
  )

  if (isLoading) {
    return <p style={{ color: 'var(--ink-2)' }}>Chargement des snapshots…</p>
  }

  if (isError) {
    return (
      <p style={{ color: 'var(--danger)' }}>
        Impossible de récupérer les snapshots: {JSON.stringify(error)}
      </p>
    )
  }

  const runSnapshots = async () => {
    const resp = await $client.POST('/api/snapshots/run', {})
    if (resp.error) {
      errorToast('Impossible de lancer le snapshot', resp.error)
    } else {
      toast({ color: 'success', title: 'Snapshot lancé !' })
    }
    refetch()
  }

  return (
    <div className="oumma-table-wrap">
      <table className="oumma-table">
        <thead>
          <tr>
            <th>
              ID{' '}
              <Button size="sm" variant="primary" onClick={runSnapshots}>
                Lancer
              </Button>
            </th>
            <th>Date</th>
            <th>Bucket</th>
            <th>Chemin</th>
            <th>Taille</th>
          </tr>
        </thead>
        <tbody>
          {(data?.snapshots ?? []).map((s) => (
            <tr key={s.id}>
              <td>{s.id}</td>
              <td>{prettyTimestamp(s.timestamp_ms)}</td>
              <td>{s.bucket}</td>
              <td>{s.path}</td>
              <td>{prettyBytes(s.bytes_size)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
